module.exports = __webpack_public_path__ + "media/images/employees/eszter-cc79806c533a1883253e42cb7f984627.png";